<script>
import axios from 'axios';
import { levelColor } from './severity';
import SpanWaterfall from './SpanWaterfall.vue';

export default {
    name: 'TraceDrawer',
    components: { SpanWaterfall },
    props: {
        traceUrl: { type: String, required: true },
        correlationId: { type: String, required: true },
    },
    emits: ['close'],
    data() {
        return {
            loading: true,
            entries: [],
        };
    },
    watch: {
        correlationId: {
            immediate: true,
            handler() {
                this.load();
            },
        },
    },
    methods: {
        levelColor,
        async load() {
            this.loading = true;
            try {
                const { data } = await axios.get(this.traceUrl, {
                    params: { correlation_id: this.correlationId },
                });
                this.entries = data.entries;
            } finally {
                this.loading = false;
            }
        },
        formatTs(ts) {
            return ts ? ts.replace('T', ' ').replace(/\+.*$/, '') : '';
        },
    },
};
</script>

<template>
    <div class="logs-trace-drawer">
        <div class="logs-trace-backdrop" @click="$emit('close')"></div>
        <div class="logs-trace-panel box box-solid">
            <div class="box-header with-border">
                <strong><i class="fa fa-link"></i> Trace</strong>
                <code>{{ correlationId }}</code>
                <button class="btn btn-xs btn-default pull-right" @click="$emit('close')">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="box-body logs-trace-body">
                <p v-if="loading" class="text-muted"><i class="fa fa-spinner fa-spin"></i> Loading…</p>
                <template v-else>
                <span-waterfall :entries="entries" />
                <ul class="logs-trace-list">
                    <li v-for="entry in entries" :key="entry.id">
                        <span class="logs-trace-dot" :style="{ background: levelColor(entry.level) }"></span>
                        <span class="text-muted">{{ formatTs(entry.ts_utc) }}</span>
                        <code v-if="entry.saga_step">{{ entry.saga_step }}</code>
                        <span v-if="entry.duration_ms != null" class="text-muted">{{ entry.duration_ms }}ms</span>
                        <span v-if="entry.attempt" class="text-muted">#{{ entry.attempt }}</span>
                        <div class="logs-trace-message">{{ entry.span_name || entry.message }}</div>
                    </li>
                    <li v-if="!entries.length" class="text-muted">No entries for this correlation id.</li>
                </ul>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped>
.logs-trace-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1040;
}
.logs-trace-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 640px;
    max-width: 90vw;
    z-index: 1050;
    margin: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.logs-trace-body {
    overflow-y: auto;
    flex: 1;
}
.logs-trace-list {
    list-style: none;
    padding-left: 0;
}
.logs-trace-list > li {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
}
.logs-trace-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
}
.logs-trace-message {
    font-family: Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
    margin-top: 3px;
    word-break: break-word;
}
</style>
